import React, { Fragment, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Slices/ParamSlice";
import { Input } from "@progress/kendo-react-inputs";
import { Checkbox } from "@progress/kendo-react-inputs";
import { useAppDispatch } from "../../Core/store.hooks";
import { getSettingsSelector, updateSettings } from "../../Settings/Slice";
import {
  ActionsLayout,
  Window,
  WindowActionsBar,
} from "@progress/kendo-react-dialogs";

interface IFilters {
  widgets: any;
  sidebarItems: any;
  positionData: any;
  closeWindow: any;
  currentDashboard?: string;
  staticContent: any;
  customSize: any;
}

const SaveDashboard = (props: IFilters) => {
  const [name, updateName] = useState<any>("");
    const [showEmptyError, updateShowEmptyError] = useState(false);
    const [showInUseError, updateShowInUseError] = useState(false);
  const [success, updateSuccess] = useState(false);
  const [setAsDefault, updateSetAsDefault] = useState(false);
  const [displayOverWriteMsg, updateDisplayOverWriteMsg] = useState(false);
  const globalParams = useSelector(getParamsSelector);
  const settings = useSelector(getSettingsSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (props.currentDashboard != null) updateName(props.currentDashboard);
  }, [props.currentDashboard]);

  useEffect(() => {
    if (globalParams.machine == null) {
      if (
        settings.customerLayout != "App Default Dashboard" &&
        settings.customerLayout != "Tab Strip"
      ) {
        updateName(settings.customerLayout);
      } else {
        updateName("");
      }
    } else {
      if (
        settings.machineLayout != "App Default Dashboard" &&
        settings.machineLayout != "Tab Strip"
      ) {
        updateName(settings.machineLayout);
      } else {
        updateName("");
      }
    }
  }, [globalParams, settings]);

    const checkboxHandler = (e: any) => {
    //  console.log(e)
    updateSetAsDefault(e.target.value);
  };

  const checkNameExists = () => {
    let exist = false;
    let dbList = JSON.parse(localStorage.getItem("savedDashboardCustomer"));
    if (globalParams.mainMachineSerialNo != null) {
      dbList = JSON.parse(localStorage.getItem("savedDashboardMachine"));
    }
    if (dbList != null && dbList != undefined) {
      for (var i = 0; i < dbList.length; i++) {
        if (dbList[i].dbName == name) {
          exist = true;
          break;
        }
      }
    }
    return exist;
  };
  const createWidgetList = (w) => {
    const ids = [];
    for (var i = 0; i < w.length; i++) {
      ids.push(w[i].props.id);
    }
    return ids;
  };
  const createSidebarList = (s) => {
    const titles = [];
    for (var i = 0; i < s.length; i++) {
      titles.push(s[i].title);
    }
    return titles;
  };
  const saveAsDefault = () => {
      let savedSettings = JSON.parse(JSON.stringify(settings));
     // console.log(savedSettings)
        if (globalParams.machine == null) {
            savedSettings.customerLayout = name;
            savedSettings.customerLayoutSession = name;
        } else {
            savedSettings.machineLayout = name;
            savedSettings.machineLayoutSession = name;
        }
      localStorage.setItem("settings_serviceview", JSON.stringify(savedSettings));
  };

    const confirmSave = () => {
       // console.log(setAsDefault, globalParams)
    updateDisplayOverWriteMsg(false);
    updateShowEmptyError(false);
    updateShowInUseError(false);
    let newDashboardSet: any = [];
    let oldList = JSON.parse(localStorage.getItem("savedDashboardCustomer"));
    if (globalParams.mainMachineSerialNo != null) {
      oldList = JSON.parse(localStorage.getItem("savedDashboardMachine"));
    }
    if (oldList != null && oldList != undefined) {
      for (var i = 0; i < oldList.length; i++) {
        if (oldList[i].dbName != name) {
          newDashboardSet.push(oldList[i]);
        }
      }
    }
    newDashboardSet.push({
      staticContent: createWidgetList(props.staticContent),
      widgets: createWidgetList(props.widgets),
      sidebarItems: createSidebarList(props.sidebarItems),
      positionData: props.positionData,
      dbName: name,
      size12: true,
    });
    if (globalParams.mainMachineSerialNo != null) {
      localStorage.setItem(
        "savedDashboardMachine",
        JSON.stringify(newDashboardSet)
      );
    } else {
      localStorage.setItem(
        "savedDashboardCustomer",
        JSON.stringify(newDashboardSet)
      );
    }
    if (setAsDefault) {
      saveAsDefault();
    }
    const newSettings: any = Object.assign({}, settings);
    if (globalParams.machine == null) {
        newSettings.customerLayout = name;

        newSettings.customerLayoutSession = name;
    } else {
        newSettings.machineLayout = name;
        newSettings.machineLayoutSession = name;
    }

    dispatch<any>(updateSettings(newSettings));
    updateSuccess(true);
  };
    const saveDashboardAs = () => {
        if (name == "") {
            updateShowEmptyError(true);
        }
        else if (name.toLowerCase() == ("Tab Strip").toLowerCase() ||
            name.toLowerCase() == ("App Default Dashboard").toLowerCase()) {
            updateShowInUseError(true);
        }
        else { 
            if (!checkNameExists()) {
                confirmSave();
            } else {
                updateDisplayOverWriteMsg(true);
            }
        }
    };
    const updateNameHandler = (e:any) => {
        if (e.toLowerCase() != ("Tab Strip").toLowerCase() &&
            e.toLowerCase() != ("App Default Dashboard").toLowerCase()) {
            updateShowInUseError(false);
        }
        updateShowEmptyError(false);
        updateName(e)
    }
  function renderContent() {
    return (
      <Fragment>
        {!success && !displayOverWriteMsg && (
          <Fragment>
            <div style={{ height: "200px" }}>
              <div className=" k-textbox-container metricComboDark">
                <label className="k-label" style={{ width: "300px" }}>
                  Dashboard Name
                </label>
                <Input
                  value={name}
                  onChange={(e) => e.target.value && updateNameHandler(e.target.value)}
                />

                <br />
                <div>
                  <Checkbox
                    defaultChecked={setAsDefault}
                    label={"Set as default"}
                    onChange={checkboxHandler}
                    style={{
                      marginTop: "20px",
                      border: "2px solid #0056b3",
                    }}
                  />
                </div>
              </div>
            {showEmptyError && (
                <div style={{ color: "red" }}>
                    Dashboard Name requires atleast one character.
                </div>
            )}{ 
              showInUseError && (
                    <div style={{ color: "red" }}>
                                    Dashboard Name Cannot be named: {name }
                    </div>
                )}
            </div>

            <WindowActionsBar layout={"stretched"}>
              <button
                type="button"
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                onClick={() => props.closeWindow()}
                style={{ width: "150px" }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                onClick={() => saveDashboardAs()}
                style={{ width: "150px" }}
              >
                Save
              </button>
            </WindowActionsBar>
          </Fragment>
        )}
        {success && !displayOverWriteMsg && (
          <Fragment>
            <div style={{ height: "200px" }}>Dashboard successfully saved.</div>

            <WindowActionsBar layout={"stretched"}>
              <button
                type="button"
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                onClick={() => props.closeWindow()}
                style={{ width: "150px" }}
              >
                Close
              </button>
            </WindowActionsBar>
          </Fragment>
        )}

        {displayOverWriteMsg && (
          <Fragment>
            <div style={{ height: "200px" }}>
              The name {name} already exists. Would you like to over write it?
            </div>

            <WindowActionsBar layout={"stretched"}>
              <button
                type="button"
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                onClick={() => updateDisplayOverWriteMsg(false)}
                style={{ width: "150px" }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
                onClick={() => confirmSave()}
                style={{ width: "150px" }}
              >
                Yes
              </button>
            </WindowActionsBar>
          </Fragment>
        )}
      </Fragment>
    );
  }
  return <Fragment>{renderContent()}</Fragment>;
};

export default SaveDashboard;
